// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer layout {
  :root {
    --space-025: calc(0.25 * var(--space-1));
    --space-05: calc(0.5 * var(--space-1));
    --space-1: 4px;
    --space-2: calc(2 * var(--space-1));
    --space-3: calc(3 * var(--space-1));
    --space-4: calc(4 * var(--space-1));
    --space-5: calc(5 * var(--space-1));
    --space-6: calc(6 * var(--space-1));
    --space-8: calc(8 * var(--space-1));
    --space-10: calc(10 * var(--space-1));
    --space-12: calc(12 * var(--space-1));
    --space-16: calc(16 * var(--space-1));
    --space-20: calc(20 * var(--space-1));
    --space-24: calc(24 * var(--space-1));
  }
  
  @property --space {
    inherits: false;
    initial-value: 0;
    syntax: '<length>';
  }
  
  .d-stack-h.d-stack-h,
  .d-stack-v.d-stack-v,
  .d-substack {
    display: flex;
    gap: var(--space);
  }
  
  .d-stack-h,
  .d-stack-h > .d-substack {
    align-items: center;
    flex-direction: row;
  
    & > * {
      margin-inline: 0 !important;
    }
  }
  
  .d-stack-v,
  .d-stack-v > .d-substack {
    flex-direction: column;
  
    & > * {
      margin-block: 0 !important;
    }
  }
  
  .d-substack {
    --space: inherit;
  }
  
  /*
   * This inline container centers its children on
   * the line box and allows them to overflow it.
   */
  .d-inline-stack {
    --space: var(--space-05); /* Different default than the other stacks! */

    align-items: center;
    display: inline-flex;
    gap: var(--space);
    height: 1lh;
    vertical-align: text-bottom;
  
    /* 0.25 em is roughly the width of a space. */
    &:not(:first-child) {
      margin-inline-start: 0.25em;
    }
  
    &:not(:last-child) {
      margin-inline-end: 0.25em;
    }
  }
  
  .space-0_25 {
    --space: var(--space-025);
  }
  
  .space-0_5 {
    --space: var(--space-05);
  }
  
  .space-1 {
    --space: var(--space-1);
  }
  
  .space-2 {
    --space: var(--space-2);
  }
  
  .space-3 {
    --space: var(--space-3);
  }
  
  .space-4 {
    --space: var(--space-4);
  }
  
  .space-5 {
    --space: var(--space-5);
  }
  
  .space-6 {
    --space: var(--space-6);
  }
  
  .space-8 {
    --space: var(--space-8);
  }
  
  .space-10 {
    --space: var(--space-10);
  }
  
  .space-12 {
    --space: var(--space-12);
  }
  
  .space-16 {
    --space: var(--space-16);
  }
  
  .space-20 {
    --space: var(--space-20);
  }
  
  .space-24 {
    --space: var(--space-24);
  }
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/stack/stack.css"],"names":[],"mappings":"AAAA;EACE;IACE,wCAAwC;IACxC,sCAAsC;IACtC,cAAc;IACd,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;IAGE,aAAa;IACb,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;IACnB,mBAAmB;;IAEnB;MACE,2BAA2B;IAC7B;EACF;;EAEA;;IAEE,sBAAsB;;IAEtB;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE;EACF;IACE,wBAAwB,EAAE,6CAA6C;;IAEvE,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,2BAA2B;;IAE3B,6CAA6C;IAC7C;MACE,2BAA2B;IAC7B;;IAEA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@layer layout {\n  :root {\n    --space-025: calc(0.25 * var(--space-1));\n    --space-05: calc(0.5 * var(--space-1));\n    --space-1: 4px;\n    --space-2: calc(2 * var(--space-1));\n    --space-3: calc(3 * var(--space-1));\n    --space-4: calc(4 * var(--space-1));\n    --space-5: calc(5 * var(--space-1));\n    --space-6: calc(6 * var(--space-1));\n    --space-8: calc(8 * var(--space-1));\n    --space-10: calc(10 * var(--space-1));\n    --space-12: calc(12 * var(--space-1));\n    --space-16: calc(16 * var(--space-1));\n    --space-20: calc(20 * var(--space-1));\n    --space-24: calc(24 * var(--space-1));\n  }\n  \n  @property --space {\n    inherits: false;\n    initial-value: 0;\n    syntax: '<length>';\n  }\n  \n  .d-stack-h.d-stack-h,\n  .d-stack-v.d-stack-v,\n  .d-substack {\n    display: flex;\n    gap: var(--space);\n  }\n  \n  .d-stack-h,\n  .d-stack-h > .d-substack {\n    align-items: center;\n    flex-direction: row;\n  \n    & > * {\n      margin-inline: 0 !important;\n    }\n  }\n  \n  .d-stack-v,\n  .d-stack-v > .d-substack {\n    flex-direction: column;\n  \n    & > * {\n      margin-block: 0 !important;\n    }\n  }\n  \n  .d-substack {\n    --space: inherit;\n  }\n  \n  /*\n   * This inline container centers its children on\n   * the line box and allows them to overflow it.\n   */\n  .d-inline-stack {\n    --space: var(--space-05); /* Different default than the other stacks! */\n\n    align-items: center;\n    display: inline-flex;\n    gap: var(--space);\n    height: 1lh;\n    vertical-align: text-bottom;\n  \n    /* 0.25 em is roughly the width of a space. */\n    &:not(:first-child) {\n      margin-inline-start: 0.25em;\n    }\n  \n    &:not(:last-child) {\n      margin-inline-end: 0.25em;\n    }\n  }\n  \n  .space-0_25 {\n    --space: var(--space-025);\n  }\n  \n  .space-0_5 {\n    --space: var(--space-05);\n  }\n  \n  .space-1 {\n    --space: var(--space-1);\n  }\n  \n  .space-2 {\n    --space: var(--space-2);\n  }\n  \n  .space-3 {\n    --space: var(--space-3);\n  }\n  \n  .space-4 {\n    --space: var(--space-4);\n  }\n  \n  .space-5 {\n    --space: var(--space-5);\n  }\n  \n  .space-6 {\n    --space: var(--space-6);\n  }\n  \n  .space-8 {\n    --space: var(--space-8);\n  }\n  \n  .space-10 {\n    --space: var(--space-10);\n  }\n  \n  .space-12 {\n    --space: var(--space-12);\n  }\n  \n  .space-16 {\n    --space: var(--space-16);\n  }\n  \n  .space-20 {\n    --space: var(--space-20);\n  }\n  \n  .space-24 {\n    --space: var(--space-24);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
